import { ErrorBoundary } from "@/lib/monitoring";
import { initDraftCleanup } from "@/store/draftMessagesAtom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { Provider as JotaiProvider } from "jotai";
import type { PropsWithChildren } from "react";
import React, { Suspense, useEffect, useState } from "react";
import { queryClient } from "./lib/queryClient";
import { appStore } from "./store/jotaiStore";

// Clean up stale draft messages once at app startup
initDraftCleanup(appStore);

// This is a lazy loaded component that is used to toggle the devtools in production
// Tanner Linsley approved approach
const ReactQueryDevtoolsProduction = React.lazy(() =>
  import("@tanstack/react-query-devtools/build/modern/production.js").then(
    (d) => ({
      default: d.ReactQueryDevtools,
    }),
  ),
);

export const AppProviders = ({ children }: PropsWithChildren) => {
  const [shouldShowDevtools, setShouldShowDevtools] = useState(false);

  useEffect(() => {
    // @ts-ignore - this is a global function that is used to toggle the devtools please don't make me type this
    window.toggleDevTools = () => setShouldShowDevtools((old: boolean) => !old);
  }, []);
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <JotaiProvider store={appStore}>
          <GoogleOAuthProvider clientId="18205873756-697soc8niqmaih3cs1l6780m45svk9r2.apps.googleusercontent.com">
            {children}
          </GoogleOAuthProvider>
        </JotaiProvider>
        <ReactQueryDevtools initialIsOpen={false} />
        {shouldShowDevtools ? (
          <Suspense fallback={null}>
            <ReactQueryDevtoolsProduction />
          </Suspense>
        ) : null}
      </QueryClientProvider>
    </ErrorBoundary>
  );
};
